import { combineReducers } from 'redux';

import paymentInfo from './payment-info';
import info from './info';


export default combineReducers({
  paymentInfo,
  info,
});



// WEBPACK FOOTER //
// ./src/widget/redux/client/reducers/channel-info/index.js